import {httpCall, httpMethod} from "./http";

export function getAllMagnitudes() {
	return httpCall(httpMethod.GET, "mobileagent/magnitude-all")
}
